@if (groupSeriesForm) {
  <form [formGroup]="groupSeriesForm" class="dialog-root">
    <h2 mat-dialog-title>{{"group_series.edit_group_series" | transloco}}</h2>

    <mat-dialog-content class="column-gap">
      <div class="row-gap">
        <mat-card class="image-card">
          <mat-card-content class="column-gap image-card-content">
            <div class="image-box">
              @if (imagePreview) {
                <img [src]="imagePreview" />
              }
            </div>
            <input type="file" accept="image/*" class="hidden" (change)="selectFile($event)" #fileUpload />
            <div class="row-gap-small">
              <button mat-icon-button (click)="deleteImage()">
                <mat-icon>delete</mat-icon>
              </button>
              <button mat-flat-button (click)="fileUpload.click()">{{"label.add_image" | transloco}}</button>
            </div>
            @if (imageError) {
              <mat-error>{{imageError}}</mat-error>
            }
          </mat-card-content>
        </mat-card>

        <mat-card class="flex">
          <mat-card-content class="column-gap">
            <div class="column-gap-small">
              <mat-label>{{"form.label.title" | transloco}}</mat-label>
              <div class="mdc-list-item__primary-text">{{ data.groupSeriesDto.title }}</div>
            </div>

            <div class="column-gap-small">
              <mat-label>{{"form.label.duration" | transloco}}</mat-label>
              <div class="mdc-list-item__primary-text">{{ data.groupSeriesDto.start | date: 'dd.MM.yyyy' }}
                - {{ data.groupSeriesDto.end | date: 'dd.MM.yyyy' }}
              </div>
            </div>

            <div class="column-gap-small">
              <mat-label>{{"form.label.employee" | transloco}}</mat-label>
              <div class="mdc-list-item__primary-text">{{ data.groupSeriesDto.therapist }}</div>
            </div>

            <mat-checkbox formControlName="hideTherapist">
              <mat-label>{{ "form.label.hide_employee" | transloco }}</mat-label>
            </mat-checkbox>

            <mat-checkbox formControlName="hideInSchedule">
              <mat-label>{{ "form.label.hide_in_schedule" | transloco }}</mat-label>
            </mat-checkbox>
          </mat-card-content>
        </mat-card>
      </div>

      <mat-card>
        <mat-card-content class="column">
          <mat-form-field hideRequiredMarker="true">
            <mat-label>{{ "form.label.description" | transloco }}</mat-label>
            <textarea matInput type="text" rows="6" formControlName="descriptionRich"></textarea>
          </mat-form-field>
        </mat-card-content>
      </mat-card>
    </mat-dialog-content>

    <mat-dialog-actions>
      <button mat-button type="button" (click)="close()">{{"button.cancel" | transloco}}</button>

      <button mat-flat-button (click)="save()">{{ "button.save" | transloco }}</button>
    </mat-dialog-actions>
  </form>
}
